import FormElementRenderer from './form.el';
import UICommon from './common';
import * as CONST from '../const';
class FormElementCheckboxRenderer extends FormElementRenderer {
    render(option, cont, index) {
        const price = UICommon.formatPrice(this.owner.getPropertyPrice(option.optionName));
        const tooltip = this.returnTooltipTrigger(), inDigital = this.checkIfOptionIsDigital(option) ? 'digital' : '', hidden = this.getHiddenClass(option), inRolled = this.checkIfOptionIsRolled(option) ? 'rolled' : '', el = document.createElement('div');
        ['fixed-padding-left', CONST.OPT_CLASS_OPTION_NORMAL, inDigital, inRolled, hidden].forEach(name => name && el.classList.add(name));
        el.id = `option_${option.optionName}`;
        el.dataset.name = option.optionName;
        el.innerHTML = `
      <label class="align-content-left" for="checkbox_${this.getElementId(option)}"><span>${option.title}</span> ${tooltip}</label>
      <div class="input-checkbox">
        <input  data-option-id="${option.id}" id="checkbox_${this.getElementId(option)}" type="checkbox" name="agree"/>
        <label for="checkbox_${this.getElementId(option)}" tabindex="${index}"></label>
      </div>
      <span class="price">${price}</span>`;
        this.appendCheckboxEl(el, cont, option);
        this.bindTooltip(option);
    }
    updateFromSummary(option, summary) {
        const el = document.querySelector(`#checkbox_${this.getElementId(option)}`);
        if (Object.hasOwn(summary.properties, option.optionName)) {
            el.setAttribute('checked', 'checked');
        }
        else {
            el.removeAttribute('checked');
        }
    }
}
export default FormElementCheckboxRenderer;
